import { z } from 'zod'

import {
  fiveSegmentDisplayColumnKeys,
  fiveSegmentSortColumnKeys,
  nineSegmentDisplayColumnKeys,
  nineSegmentSortColumnKeys,
} from '~/apps/ninesegsAnalyzer/utils/standardAnalysis'
import { dataDisplayTypes, segmentDisplayTypes } from '~/utils'

import {
  type RestoringParams,
  type RestoringParamsAddition,
  type RestoringParamsOrigin,
} from '../types'

const schema2Origin = z.object({
  version: z.literal(2),
  revision: z.number(),
  brandGroupId: z.number(),
  dataDisplayType: z.enum(dataDisplayTypes),
  segmentDisplayType: z.enum(segmentDisplayTypes),
  brandIds: z.array(z.number()),
  questionIds: z.array(z.string()),
  fiveSegmentSortValue: z
    .object({
      columnKey: z.enum(fiveSegmentSortColumnKeys),
      ascending: z.boolean(),
    })
    .nullable(),
  nineSegmentSortValue: z
    .object({
      columnKey: z.enum(nineSegmentSortColumnKeys),
      ascending: z.boolean(),
    })
    .nullable(),
  hiddenRowIds: z.array(z.string()),
  fiveSegmentHiddenColumnKeys: z.array(z.enum(fiveSegmentDisplayColumnKeys)),
  nineSegmentHiddenColumnKeys: z.array(z.enum(nineSegmentDisplayColumnKeys)),
  hash: z.string(),
}) satisfies z.ZodSchema<RestoringParamsOrigin>

const schema2Addition = z.object({
  customerAttributeIds: z.array(z.string()),
  fiveSegmentComment: z.string(),
  nineSegmentComment: z.string(),
}) satisfies z.ZodSchema<RestoringParamsAddition>

export const schema2 = schema2Origin.merge(
  schema2Addition.partial(),
) satisfies z.ZodSchema<RestoringParams>
